<canvas #canvas
        (click)="onCanvasClick($event)"></canvas>
